import { Helmet } from "react-helmet-async";
import { filter } from "lodash";
import { sentenceCase } from "change-case";
import { useEffect, useState } from "react";
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Avatar,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TableHead,
  CircularProgress,
  Box,
} from "@mui/material";
// components

import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";

import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
// ----------------------------------------------------------------------

export default function GameUserCardPage() {
  const navigate = useNavigate();
  const [card, setCard] = useState(null);
  const [match, setMatch] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.has("match_id")) {
      let matchId = searchParams.get("match_id");
      let userId = searchParams.get("user_id");
      setMatch(matchId);
      axios
        .get(
          `${process.env.REACT_APP_API_BASE_URL}/admin/users/${userId}/game/${matchId}/card`
        )
        .then(function (response) {
          setCard(response.data.card);
        });
    } else {
      navigate("/404");
    }
  }, [setSearchParams, searchParams, navigate]);

  return (
    <>
      <Helmet>
        <title> Bingo Game Questions </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Game Users
          </Typography>

          <Button
            variant="contained"
            startIcon={<Iconify icon="eva:arrow-ios-back-outline" />}
            onClick={() => navigate(`/dashboard/game/users?match_id=${match}`)}
          >
            Back To Users List
          </Button>
        </Stack>
        {card !== null && (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={5}
          >
            Card state: {card.inPlay ? <>IN PLAY</> : <>UPCOMING</>}
          </Stack>
        )}

        <Card>
          {card === null ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell>Text</TableCell>
                      <TableCell>Level</TableCell>
                      <TableCell>Logo</TableCell>
                      <TableCell>Is Correct</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {card.cells.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {row.order}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.targetName} {row.text}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.level}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <Avatar
                            alt="Logo"
                            src={
                              row.type === "team"
                                ? `https://allstarvotefilesde.blob.core.windows.net/nhl-team-logos/${row.logoId}.svg`
                                : `https://cms.nhl.bamgrid.com/images/headshots/current/168x168/${row.logoId}.jpg`
                            }
                          />
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.isCorrect ? (
                            <Iconify
                              icon={"eva:checkmark-circle-2-outline"}
                              sx={{ color: "green" }}
                            />
                          ) : (
                            <Iconify
                              icon={"eva:close-circle-outline"}
                              sx={{ color: "red" }}
                            />
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          )}
        </Card>
      </Container>
    </>
  );
}
